import { render, staticRenderFns } from "./memberbalance-stock-transfer-balance.vue?vue&type=template&id=151584ee&"
import script from "./memberbalance-stock-transfer-balance.vue?vue&type=script&lang=js&"
export * from "./memberbalance-stock-transfer-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports